import { FunctionComponent } from 'react'
import Toggle from '@kvika/audur-toggle'

type Props = {
	toggled: boolean
	setToggled(toggled: boolean): void
}

const AudurSwitch: FunctionComponent<Props> = ({ toggled, setToggled }) => {
	return <Toggle isChecked={toggled} onChange={(e) => setToggled(e.target.checked)} />
}

export default AudurSwitch
